import { useId } from 'react';

import { unitMapping } from 'lib/style';
import { Color } from 'style/types';

export const Flame = ({
  size = 2,
  color,
}: {
  size?: keyof typeof unitMapping;
  color?: Color;
}) => {
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 19 24"
      fill="none"
    >
      <path
        d="M14.0842 9.02275H14.5321H14.5349V6.34364L18.653 11.3547V18.373L12.8244 23.986L10.7808 16.125H7.75178L5.4786 24H5.35822L0 18.7874V5.78934L4.79552 9.38108H5.39181V0L14.0842 9.02275Z"
        fill={`url(#${id})`}
      />
      <defs>
        <linearGradient
          id={id}
          x1="9.32649"
          y1="24"
          x2="9.32649"
          y2="3.5289e-07"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color || '#FEF314'} />
          <stop offset="1" stopColor={color || '#FF4E22'} />
        </linearGradient>
      </defs>
    </svg>
  );
};
